<style lang="stylus" scope>
@import '../../static/stylus/main.styl'
</style>
<template lang="pug">
c-app#login-layout
  c-content
    section.sign.u-m-auto
      .card.border-0.p-0.rounded-0
        .col-12.px-4.pt-5
          img.mb-5(src='../assets/logo-adherencia.png', alt='Adherencia' class='img-fluid')
        .card-body.pb-0
          c-form.login-form
            .col-12
              .form-group
                label.w-100 Usuario
                  c-form-input.mt-2(v-model='username', type='email', @keyup.enter.native="auth()")
              .form-group
                label.w-100 Contraseña
                  c-form-input.mt-2(v-model='password', type='password', @keyup.enter.native="auth()")
        .form-group.mt-5.mb-0
          button.btn.btn-primary.m-auto(type='submit', @click.prevent='auth', block='') Ingresar
    #login-footer.mt-2.flex-row.d-flex.flex-wrap.justify-content-center
      .d-flex.col-12.pb-2.pt-3.justify-content-center
        a.col-1.p-0(href="http://www.persis.cl" target="_blank")
          img.logo-persis(src="../../static/images/logo.svg" alt="Persis")
      .d-flex.col-12.py-1.justify-content-center
        a.text-white(href="http://www.persis.cl" target="_blank") Desarrollado por 
          span.font-weight-bold Persis
          | &nbsp; &copy;
              
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginView',
  beforeRouteEnter (to, from, next) {    
    next()
  },
  props: ['logout'],
  methods: {
    ...mapActions('auth', [
      'login', 'logOut'
    ]),
    ...mapActions('objective', [
      'cleanStore'
    ]),
    ...mapActions('plan', [
      'cleanStorePlan'
    ]),
    auth () {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.login({username: this.username, password: this.password})
        .then((res) => {
          loading.hide()
          if (res.success) {
            vm.cleanStore()
            vm.cleanStorePlan().then(() => {
              vm.user = vm.$store.getters['auth/getUserInfo'];
              if(this.redirect != '/' && this.redirect != null) { 
                vm.$router.push({ path: this.redirect })
              } else {
                if (vm.user.profile.name == 'Consultor') {                            
                  vm.$router.push({ path: '/consultor' })
                } else if (vm.user.profile.name == 'Consultor externo') {
                  vm.$router.push({ path: '/dashboard' })
                } else {                  
                  vm.$router.push({ path: '/home' })
                }
              }
            }, (error) => {
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: res.message,
                closeable: true,
                duration: 5000
              })  
            })            
          } else {            
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: res.message,
              closeable: true,
              duration: 5000
            })
          }
        }, (error) => {          
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
    }
  },
  mounted() {
    const vm = this;
    vm.logOut();
    vm.login();
  },
  data () {
    return {
      email: '',
      password: '',
      redirect: null,
      isLogOut: this.logout,
      user: {}
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/login.vue